import PropTypes from 'prop-types';
import AudioMeterIcon from './AudioMeterIcon';
import volume$, { setStream, stopStream } from './volume$';

/*
#tailwind
*/

const AudioMeter = ({ size, fill, ...other }) => <AudioMeterIcon size={size} fill={fill} {...other} />;

AudioMeter.setStream = setStream;
AudioMeter.stopStream = stopStream;
AudioMeter.volume$ = volume$;

export default AudioMeter;

AudioMeter.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

AudioMeter.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};
